import { render, staticRenderFns } from "./CustomFieldImage.vue?vue&type=template&id=947eb94a&scoped=true"
import script from "./CustomFieldImage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldImage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomFieldImage.vue?vue&type=style&index=0&id=947eb94a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947eb94a",
  null
  
)

export default component.exports